// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import ShopMiniBasketResourceViewModel from '../../../../viewModel/resource/ShopMiniBasketResourceViewModel';
import ShopMiniBasketResourceDTO from '../../dto/resource/ShopMiniBasketResourceDTO';

export default abstract class ShopMiniBasketResourceModel extends BaseModel<ShopMiniBasketResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  * @type {uuid}
  */
  get publicBasketId() { return this.dto.publicBasketId; }
  set publicBasketId(value) { this.dto.publicBasketId = value; }
  /**
  * @type {int32}
  */
  get itemsTotalQuantity() { return this.dto.itemsTotalQuantity; }
  set itemsTotalQuantity(value) { this.dto.itemsTotalQuantity = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    this.dto.publicBasketId = qs.publicbasketid;
    value = Number.parseFloat(qs.itemstotalquantity);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.itemsTotalQuantity = value;
  }
}
